import { Link } from "react-router-dom";
import MovieCard from "@/components/base/MovieCard";
import { getNewMovies } from "@/mocks/movies";

export default function LatestUpdates() {
  const newMovies = getNewMovies();

  return (
    <section className="px-4 md:px-6 py-10 md:py-14">
      <div className="max-w-screen-2xl mx-auto">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
              最新更新
            </h2>
            <p className="text-sm text-foreground-500 mt-1">最新上线的精彩内容</p>
          </div>
          <Link
            to="/category/all"
            className="text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
          >
            更多 <i className="ri-arrow-right-line ml-1 text-xs"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4 md:gap-5">
          {newMovies.map((movie) => (
            <MovieCard key={movie.id} movie={movie} />
          ))}
        </div>
      </div>
    </section>
  );
}